module.exports = __webpack_public_path__ + "static/img/left-num-row-7.bf4f85b1.png";